export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 pt-20 pb-10 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.4)_0%,transparent_50%)]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <span className="text-2xl font-heading font-bold text-white">91吃瓜</span>
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-sm">
              全网黑料一网打尽，91吃瓜平台每日更新网红博主与校园素人最辣眼视频。吃瓜老家最新地址不变，独家深扒真相揭秘，即刻吃瓜不错过任何爆点。
            </p>

            <div className="flex gap-3 mb-6">
              <a href="#" className="w-9 h-9 rounded-lg border border-white/15 flex items-center justify-center text-white/50 hover:text-accent-400 hover:border-accent-400 transition-all cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-white/15 flex items-center justify-center text-white/50 hover:text-accent-400 hover:border-accent-400 transition-all cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-white/15 flex items-center justify-center text-white/50 hover:text-accent-400 hover:border-accent-400 transition-all cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-white/15 flex items-center justify-center text-white/50 hover:text-accent-400 hover:border-accent-400 transition-all cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>

            <p className="text-2xl md:text-3xl font-heading font-bold text-white leading-snug">
              吃瓜就上
              <br />
              <span className="text-accent-400">91吃瓜</span>
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { id: 'hero', label: '首页' },
                { id: 'features', label: '热点爆料' },
                { id: 'cards', label: '最新爆料' },
                { id: 'carousel', label: '焦点专题' },
                { id: 'about', label: '关于平台' },
              ].map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                  className="text-white/45 text-sm hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">热门专题</h4>
            <nav className="flex flex-col gap-2.5">
              {['明星塌房实录', '网红翻车合集', '素人爆料专区', '娱乐圈内幕', '91吃瓜大事件'].map((label) => (
                <a
                  key={label}
                  href="#index"
                  onClick={(e) => { e.preventDefault(); scrollTo('index'); }}
                  className="text-white/45 text-sm hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">合作伙伴</h4>
            <p className="text-white/30 text-xs">
              更多合作伙伴信息敬请期待
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; 2026 91吃瓜（九一吃瓜网）版权所有，保留一切权利。
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/30 text-xs hover:text-white/50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-white/30 text-xs hover:text-white/50 transition-colors cursor-pointer">使用条款</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }} className="text-white/30 text-xs hover:text-white/50 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}